import { render, staticRenderFns } from "./ProductGalleries.vue?vue&type=template&id=d15892c6&scoped=true&"
import script from "./ProductGalleries.vue?vue&type=script&lang=js&"
export * from "./ProductGalleries.vue?vue&type=script&lang=js&"
import style0 from "./ProductGalleries.vue?vue&type=style&index=0&id=d15892c6&prod&scoped=true&lang=css&"
import style1 from "./ProductGalleries.vue?vue&type=style&index=1&id=d15892c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15892c6",
  null
  
)

export default component.exports